import { Alert, Card, List, Tag, Typography } from "antd"
import type { CatalogInclude, TemplateDefinition } from "../../../types/regulatory"
import { changedDefinitionKeys } from "../../../utils/regulatory"
import { JsonDetails } from "./CatalogUI"
export function RevisionComparison({
  before,
  after,
  beforeIncludes,
  afterIncludes,
}: {
  before: TemplateDefinition
  after: TemplateDefinition
  beforeIncludes: CatalogInclude[]
  afterIncludes: CatalogInclude[]
}) {
  const oldPoints = new Map(before.points.map((point) => [point.id, point]))
  const newPoints = new Map(after.points.map((point) => [point.id, point]))
  const changes = [...newPoints]
    .flatMap(([id, point]) => {
      const old = oldPoints.get(id)
      if (!old) return [{ id, label: point.label, kind: "Ajout", fields: [] as string[] }]
      const fields = changedDefinitionKeys(old, point)
      return fields.length ? [{ id, label: point.label, kind: "Modification", fields }] : []
    })
    .concat(
      [...oldPoints]
        .filter(([id]) => !newPoints.has(id))
        .map(([id, point]) => ({
          id,
          label: point.label,
          kind: "Retrait",
          fields: [] as string[],
        })),
    )
  const metadata = changedDefinitionKeys(before, after).filter(
    (key) => key !== "points" && key !== "includes",
  )
  const orderChanged =
    JSON.stringify(before.points.map((point) => point.id)) !==
    JSON.stringify(after.points.map((point) => point.id))
  const includesChanged =
    JSON.stringify(beforeIncludes.map((link) => [link.templateUuid, link.revisionUuid])) !==
    JSON.stringify(afterIncludes.map((link) => [link.templateUuid, link.revisionUuid]))
  return (
    <div className="regulatory-point-detail">
      <Typography.Paragraph>
        Comparaison de « {before.name} » (version {before.version}) avec « {after.name} » (version{" "}
        {after.version}).
      </Typography.Paragraph>
      <Alert
        showIcon
        type="info"
        message={`${changes.length} points modifiés · ${metadata.length} champs de modèle modifiés`}
        description={
          <>
            {orderChanged && <Tag>Ordre des points modifié</Tag>}
            {includesChanged && <Tag>Modules ou révisions incluses modifiés</Tag>}
          </>
        }
      />
      <List
        dataSource={changes}
        renderItem={(change) => (
          <List.Item>
            <Typography.Text>{change.label}</Typography.Text>
            <span>
              <Tag>{change.kind}</Tag>
              {change.fields.join(", ")}
            </span>
          </List.Item>
        )}
      />
      <div className="regulatory-comparison">
        <Card title="Définition avant">
          <JsonDetails value={{ definition: before, includes: beforeIncludes }} />
        </Card>
        <Card title="Définition après">
          <JsonDetails value={{ definition: after, includes: afterIncludes }} />
        </Card>
      </div>
    </div>
  )
}
